import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, style, animate, transition, query, state, keyframes, stagger } from '@angular/animations';

import { CommonService } from "../common.service";
import { ApiService} from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";


@Component({
  selector: 'app-case-practice-team-begin',
  animations: [
    trigger(
    'completedAnimation', [
      transition(':enter', [
        query('div#tipBox', [style({transform: 'translate(-300%)'})]),
        query('img#allPeople', [style({opacity: 0}), animate('200ms 100ms', style({opacity: 1}))]),
        query('div#tipBox', [animate('200ms 200ms', style({transform: 'translate(0%)'}))]),
      ])
    ]
  ),
  trigger(
  'casePracticeTeamBeginAnimation', [
    transition(':enter', [ style({opacity: 0}), animate('0s', style({opacity: 1}))]),
    transition(':leave', [
      style({opacity: 1}),
      animate('200ms', style({opacity: 0}))]),
    ]
  ),
  trigger(
    'videoAnimation', [
      transition(':enter', [
        style({opacity: 0}),
        animate('0s ease-out', style({opacity: 1}))
      ]),
      transition(':leave', animate('1s', keyframes([
         style({opacity: 1, transform: 'translate(0%, 0%) scale(100, 100)'}),
         style({opacity: 0.8, transform: 'translate(20%, -20%) scale(80, 80)'}),
         style({opacity: 0.6, transform: 'translate(40%, -40%) scale(60, 60)'}),
         style({opacity: 0.4, transform: 'translate(60%, -60%) scale(40, 40)'}),
         style({opacity: 0.2, transform: 'translate(80%, -80%) scale(20, 20)'}),
         style({opacity: 0, transform: 'translate(100%, -100%) scale(10, 10)'}),
         style({opacity: 0, transform: 'translate(100%, -100%) scale(1, 1)'})
       ]))),
  ])
  ],
  templateUrl: './case-practice-team-begin.component.html',
  styleUrls: ['./case-practice-team-begin.component.css',]
})
export class CasePracticeTeamBeginComponent implements OnInit, AfterViewInit{
    multiExerciseMetaId: any;
    @Output() onGoToMain = new EventEmitter<any>();
    @Output() onGoToVideo = new EventEmitter<any>();

    learningPathId:any;
    practiceMetaId:any;
    exercises: any;
    completed: any;
    videoShow: boolean;
  assetsRoute: string = "../../assets";
    flag:boolean=false
    type : string
  constructor(private commonService:CommonService,
              private apiService: ApiService,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    let that = this;
    this.route.queryParams.subscribe(queryParams=>{
      this.type=queryParams['type']
    })
    this.route.params.subscribe(params => {
      this.multiExerciseMetaId = params['multiExerciseMetaId'];
      this.learningPathId = params['learningPathId'];
      this.practiceMetaId = params['practiceMetaId'];
      this.apiService.ajax({

        'type':'get',
        'url':'/api/getExercise/'+this.multiExerciseMetaId

      }).subscribe(result=>{
        this.exercises = result;
        let temp = true;
        this.exercises.forEach(function (item,index) {
          if(item.status != 2){

            temp = false;

          }
        });
        this.exercises.filter(item=>{
          if(item.status===2){
            this.flag=true
          }
        })
        this.completed = temp;
        console.log(this.flag)
        if(!this.flag){
          const exerciseMetaId=$('#exerciseMetaId').val()
          this.apiService.learingTime({learningPathMetaId:localStorage.getItem("learningPathMetaId"),module:'情景模拟',courseUnit:'',type:1,btnName:'41',userId:localStorage.getItem("userId")}).subscribe(result=>{
            console.log(result)
          })
          console.log(exerciseMetaId)
          this.commonService.sendPostMessage(0,'isPractice' +'Complete')
        }
      });

    });
    // this.videoShow = false;
    // document.getElementById('video').addEventListener("ended",function(){
    //
    //   that.videoShow = false;
    //
    // });


  }

  ngAfterViewInit(){
    this.commonService.initPage({
      'backgroundColor':'white'
    });
  }

  onItemClick(i){
    if(this.exercises[i].status!=2){
      let link = ['case-practice-team-main', this.exercises[i].id,this.multiExerciseMetaId,this.learningPathId,this.practiceMetaId];
      if(this.type){
        this.router.navigate(link,{queryParams:{type:'huatek'}});
      }else{
        this.router.navigate(link);
      }
    }
  }

  goToReport(){
    // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':localStorage.getItem('learningPathMetaId'),'module':'退出情景模拟1'}).then();
    this.apiService.getmultiKas(this.multiExerciseMetaId).subscribe(result=>{
      if(result){
        this.apiService.ajax({
          url: "/sr/insideapi/getlevel",
          type: "post",
          dataType:'json',
          contentType:'application/json;charset=utf-8',
          data:JSON.stringify(this.getKaList(result) ),
          async: false,
        })
      }

      let link = ['case-practice-team-report',this.multiExerciseMetaId,this.learningPathId,this.practiceMetaId];
      if(this.type){
        this.router.navigate(link,{queryParams:{type:'huatek'}});
        this.commonService.sendPostMessage(2,'isPractice' +'Complete')
      }else{
        this.router.navigate(link);
      }
    })
    const exerciseMetaId=$('#exerciseMetaId').val()
      this.apiService.learingTime({learningPathMetaId:localStorage.getItem("learningPathMetaId"),module:'情景模拟',courseUnit:'',type:2,btnName:'41',userId:localStorage.getItem("userId")}).subscribe(result=>{
        console.log(result)
      })
      console.log(exerciseMetaId)
  }


  /*
  格式化KA对象方法
   report：传递一个报告对象
 */
  goToVideo(){
    let link = ['case-practice-team', this.learningPathId, this.practiceMetaId, 3, this.multiExerciseMetaId];
    if(this.type){
      this.router.navigate(link,{queryParams:{type:'huatek'}});
    }else{
      this.router.navigate(link);
    }
    this.videoShow = true;
  }

  getKaList(report){
		let kaJson = {id:this.learningPathId,name:"打造高效团队",type:"exercise",kas:{},exercisesId:this.practiceMetaId,questionId:null,optionId:null};
		if(report){
			for(let i = 1;i <= 6; i++){
				let kaItem = report["ka" + i];
				if(kaItem){
					//kaJson.kas.push({name:kaItem.name,value:kaItem.total});
					kaJson.kas[kaItem.name] = kaItem.total;
				}
			}
		}
		return kaJson;
	}

}



// WEBPACK FOOTER //
// ./src/app/case-practice-team-begin/case-practice-team-begin.component.ts